module.exports = __webpack_public_path__ + "img/02-AppMyTip-03.ceb3cbe8.png";